export const formatDate = (date) => {
    return new Date(date).toLocaleDateString();
};

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
};

// Function to get cookie value by name
export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${encodeURIComponent(name)}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

export const setCookie = (name, value, opts = {}) => {
  const {
    days = 1,
    domain,
    path = '/',
    sameSite = 'Lax', // or 'None' if you ever embed on non-parki.cloud pages
    secure = true
  } = opts;

  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; Expires=${expires}; Path=${path}; SameSite=${sameSite}`;
  if (secure) cookie += '; Secure';
  if (domain) cookie += `; Domain=${domain}`;
  document.cookie = cookie;
};

// work out if this is a user that we should log their usage history
export const shouldLogUsage = () => {

    // get the user from local storage
    const user = JSON.parse(localStorage.getItem('user'));
    const userType = user?.userType || 'customer';
    const isImpersonating = localStorage.getItem('isImpersonating') === 'true';

    // if the user type is a customer and we're not impersonating, log their usage
    if (userType === 'customer' && !isImpersonating) {
        return true;
    }
    return false;
};